// Cevrimdisi/gecici hata yazma kuyrugu: baglanti koptugunda edit istekleri burada
// birikir, baglanti gelince otomatik gonderilir. localStorage'da kalici (sekme kapansa da durur).
const KEY = "ls_pending_writes_v1";

function load() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]");
  } catch {
    return [];
  }
}

function save(arr) {
  try {
    localStorage.setItem(KEY, JSON.stringify(arr));
  } catch {
    /* kota dolu -> sessiz gec */
  }
}

export function queueSize() {
  return load().length;
}

export function all() {
  return load();
}

// item: { method:"post"|"patch", url, body, label }
export function enqueue(item) {
  const arr = load();
  arr.push({
    ...item,
    id: item.id || `${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
    ts: Date.now(),
  });
  save(arr);
  return arr.length;
}

export function remove(id) {
  save(load().filter((x) => x.id !== id));
}

export function clear() {
  save([]);
}
